import { render, staticRenderFns } from "./SvgD3.vue?vue&type=template&id=644a9257&scoped=true"
import script from "./SvgD3.vue?vue&type=script&lang=js"
export * from "./SvgD3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a9257",
  null
  
)

export default component.exports